export function readAppearancePreference() {
 const value=window.localStorage.getItem("toto-appearance");
 return ["light","dark","system"].includes(value)?value:"light";
}
export function readAppearance() {
 const choice=readAppearancePreference();
 return choice==="dark"||(choice==="system"&&window.matchMedia?.("(prefers-color-scheme: dark)").matches)?"smoke":"frost";
}
export function saveAppearance(value) {
 window.localStorage.setItem("toto-appearance",["light","dark","system"].includes(value)?value:"light");
 window.dispatchEvent(new Event("toto-appearance-changed"));
}
